import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _bulkDeleteQuestionEntriesRequest = {};
var _bulkDeleteQuestionEntriesResponse = {};
var _bulkUpdateQuestionEntryRequest = {
    questionEntries: '_maskedQuestionEntry',
};
var _bulkUpdateQuestionEntryResponse = {
    results: '_bulkUpdateQuestionEntryResult',
};
var _bulkUpdateQuestionEntryResult = { questionEntry: '_questionEntry' };
var _createQuestionEntryRequest = { questionEntry: '_questionEntry' };
var _createQuestionEntryResponse = { questionEntry: '_questionEntry' };
var _deleteQuestionEntryRequest = {};
var _deleteQuestionEntryResponse = {};
var _design = { poll: '_pollDesign' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getQuestionEntryRequest = {};
var _getQuestionEntryResponse = { questionEntry: '_questionEntry' };
var _image = { media: '_media' };
var _imageData = { image: '_media' };
var _item = { image: '_image', video: '_video' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _label = { sortOrder: 'google.protobuf.DoubleValue' };
var _listQuestionEntriesRequest = {};
var _listQuestionEntriesResponse = { questionEntries: '_questionEntry' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _maskedQuestionEntry = {
    fieldMask: 'google.protobuf.FieldMask',
    questionEntry: '_questionEntry',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _queryQuestionEntriesRequest = {};
var _queryQuestionEntriesResponse = { questionEntries: '_questionEntry' };
var _questionEntry = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    sortOrder: 'google.protobuf.DoubleValue',
    richContent: '_richContent',
    labels: '_label',
};
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _setQuestionEntryLabelsRequest = { labels: '_label' };
var _setQuestionEntryLabelsResponse = { questionEntry: '_questionEntry' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = { questionEntry: '_questionEntry' };
var _updateQuestionEntryRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    questionEntry: '_questionEntry',
};
var _updateQuestionEntryResponse = { questionEntry: '_questionEntry' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
function resolveWixFaqQuestionentryV2QuestionEntryServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/question-entry',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/question-entry',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/question-entry',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/faq/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/faq/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/faq/v2/question-entries',
                destPath: '/v2/question-entries',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
        _: [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/faq-server/v2/question-entries',
                destPath: '/v2/question-entries',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-question-entries',
                destPath: '/v2/draft-question-entries',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a question entry with the provided details including question text, answer content, and category assignment.
 * The question entry must be assigned to an existing category and can optionally include labels for additional organization.
 */
export function createQuestionEntry(payload) {
    var _a = serializer(_createQuestionEntryRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createQuestionEntryResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __createQuestionEntry(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'POST',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.CreateQuestionEntry',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/question-entries',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createQuestionEntry.fromReq = fromReq;
    __createQuestionEntry.__isAmbassador = true;
    return __createQuestionEntry;
}
/** Retrieves a single question entry by ID. */
export function getQuestionEntry(payload) {
    var _a = serializer(_getQuestionEntryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getQuestionEntryResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getQuestionEntry(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'GET',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.GetQuestionEntry',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/question-entries/{questionEntryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getQuestionEntry.fromReq = fromReq;
    __getQuestionEntry.__isAmbassador = true;
    return __getQuestionEntry;
}
/**
 * Updates a question entry.
 *
 * Each time the question entry is updated, `revision` increments by 1.
 * The current `revision` must be specified when updating the question entry.
 * This ensures you're working with the latest version of a question entry and prevents unintended overwrites.
 *
 * To update multiple question entries, call the Bulk Update Question Entry method.
 *
 * To update only the question entry's `extendedFields` field, call the Update Extended Fields method.
 *
 * To update only the question entry's labels, call the Set Question Entry Labels method.
 */
export function updateQuestionEntry(payload) {
    var _a = serializer(_updateQuestionEntryRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateQuestionEntryResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __updateQuestionEntry(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'PATCH',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.UpdateQuestionEntry',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/question-entries/{questionEntry.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateQuestionEntry.fromReq = fromReq;
    __updateQuestionEntry.__isAmbassador = true;
    return __updateQuestionEntry;
}
/**
 * Deletes a question entry.
 *
 * Deleting a question entry permanently removes it from the site's Wix FAQ dashboard page.
 *
 * To delete multiple question entries, call the Bulk Delete Question Entries method.
 */
export function deleteQuestionEntry(payload) {
    var _a = serializer(_deleteQuestionEntryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteQuestionEntryResponse, {}).fromJSON;
    function __deleteQuestionEntry(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'DELETE',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.DeleteQuestionEntry',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/question-entries/{questionEntryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteQuestionEntry.fromReq = fromReq;
    __deleteQuestionEntry.__isAmbassador = true;
    return __deleteQuestionEntry;
}
/**
 * Retrieves a list of question entries, given the specified filters and paging.
 *
 * For field support for filters and sorting, see [Question Entries V2: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/faq-app/faq/question-entry-v2/supported-filters).
 *
 * Use the `fieldSet` parameter to control whether sharing links are included in the response.
 */
export function listQuestionEntries(payload) {
    var _a = serializer(_listQuestionEntriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listQuestionEntriesResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __listQuestionEntries(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'GET',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.ListQuestionEntries',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/question-entries',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listQuestionEntries.fromReq = fromReq;
    __listQuestionEntries.__isAmbassador = true;
    return __listQuestionEntries;
}
/**
 * Retrieves question entries, given the provided paging, filtering, and sorting.
 *
 * For field support for filters and sorting, see [Question Entries V2: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/faq-app/faq/question-entry-v2/supported-filters).
 */
export function queryQuestionEntries(payload) {
    var _a = serializer(_queryQuestionEntriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryQuestionEntriesResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __queryQuestionEntries(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'POST',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.QueryQuestionEntries',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/question-entries/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryQuestionEntries.fromReq = fromReq;
    __queryQuestionEntries.__isAmbassador = true;
    return __queryQuestionEntries;
}
/**
 * Deletes multiple question entries.
 *
 * Deleting a question entry permanently removes it from the site's Wix FAQ dashboard page.
 *
 * To delete a single question entry, call the Delete Question Entry method.
 */
export function bulkDeleteQuestionEntries(payload) {
    var _a = serializer(_bulkDeleteQuestionEntriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteQuestionEntriesResponse, {}).fromJSON;
    function __bulkDeleteQuestionEntries(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'POST',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.BulkDeleteQuestionEntries',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/bulk/question-entries/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteQuestionEntries.fromReq = fromReq;
    __bulkDeleteQuestionEntries.__isAmbassador = true;
    return __bulkDeleteQuestionEntries;
}
/** Updates extended fields of a question entry without incrementing `revision`. */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'POST',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.UpdateExtendedFields',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/question-entries/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
/**
 * Sets `labels` for a question entry.
 *
 * This method replaces all existing labels for the question entry.
 * To clear all labels, specify an empty labels array.
 */
export function setQuestionEntryLabels(payload) {
    var _a = serializer(_setQuestionEntryLabelsRequest, { _label: _label }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setQuestionEntryLabelsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __setQuestionEntryLabels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'PATCH',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.SetQuestionEntryLabels',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/question-entries/{questionEntryId}/labels',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setQuestionEntryLabels.fromReq = fromReq;
    __setQuestionEntryLabels.__isAmbassador = true;
    return __setQuestionEntryLabels;
}
/**
 * Updates multiple question entries.
 *
 * Each time a question entry is updated, its `revision` increments by 1.
 * The current `revision` must be specified when updating the question entry.
 * This ensures you're working with the latest version of a question entry and prevents unintended overwrites.
 *
 * To update a single question entry, call the Update Question Entry method.
 */
export function bulkUpdateQuestionEntry(payload) {
    var _a = serializer(_bulkUpdateQuestionEntryRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _maskedQuestionEntry: _maskedQuestionEntry,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateQuestionEntryResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkUpdateQuestionEntryResult: _bulkUpdateQuestionEntryResult,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _label: _label,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _questionEntry: _questionEntry,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __bulkUpdateQuestionEntry(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.question_entry.v2.question_entry',
            method: 'POST',
            methodFqn: 'wix.faq.questionentry.v2.QuestionEntryService.BulkUpdateQuestionEntry',
            url: resolveWixFaqQuestionentryV2QuestionEntryServiceUrl({
                protoPath: '/v2/bulk/question-entries/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateQuestionEntry.fromReq = fromReq;
    __bulkUpdateQuestionEntry.__isAmbassador = true;
    return __bulkUpdateQuestionEntry;
}
//# sourceMappingURL=http.impl.js.map